// import React from 'react';
import React, {Component} from 'react';
import Helmet from 'react-helmet';
import Welcome from '../components/Welcome/Welcome'
import config from '../../config/SiteConfig';

export default class Index extends Component {
	render(){	
	  return (
	  	<div>
		  	<Helmet title={`Home | ${config.siteTitle}`} />
		  	<Welcome/>
	  	</div>
	  );
	}
};




// WEBPACK FOOTER //
// ./src/pages/index.jsx